import _includesInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/includes';
import _someInstanceProperty from '@babel/runtime-corejs3/core-js-stable/instance/some';
import _Object$keys from '@babel/runtime-corejs3/core-js-stable/object/keys';
import { isValidElement } from 'react';

function isClassComponent(component) {
  return !!(typeof component === 'function' && !!component.prototype.isReactComponent);
}
function isFunctionComponent(component) {
  var _context;
  return !!(typeof component === 'function' && _includesInstanceProperty(_context = String(component)).call(_context, 'return React.createElement'));
}
function isReactComponent(component) {
  return !!(isClassComponent(component) || isFunctionComponent(component));
}

/**
 * Indicates if one or more translation placeholders are a React component or element.
 * @param placeholders - The translation string placeholders.
 * @returns - True if at least one placeholder is a React component or element; otherwise false.
 */
function containsComponentOrElement(placeholders) {
  var _context2;
  return _someInstanceProperty(_context2 = _Object$keys(placeholders)).call(_context2, function (key) {
    return isReactComponent(placeholders[key]) || /*#__PURE__*/isValidElement(placeholders[key]);
  });
}

export { containsComponentOrElement as default };
